import {Component, Inject, Mixins, Prop} from "vue-property-decorator";
import {Columns} from "~/components/grid/columns";
import {Label} from "~/components/forms/label";
import {Column} from "~/components/grid/column";
import XSelect from "~/components/forms/x-select";
import {getClientTileSetEntities, getClientTileSets} from "~/modules/settings/services";
import iconDelete from '~/assets/inline-svg/icon_delete_v2.svg?inline';
import AutoSuggest from "~/components/autosuggest";
import {SimpleModal} from "~/components/modals/simple-modal";
import {AppSettings} from "~/lib/app-settings";

@Component
export class TerritoryEditModal extends Mixins(SimpleModal) {

  @Inject() appSettings: AppSettings;
  @Prop({ type: Object, required: true }) territory: {tsId: number; geoCodes: string[]};
  private clientTileSets: {id: number; label: string}[] = [];
  private selectedTileSet: {id: number; label: string} = null;
  private selectedTileSetEntities: {geoCode: string; name: string}[] = [];
  private lastEntitiesSearchResult: {geoCode: string; name: string}[] = null;

  async created(){
    this.clientTileSets = await getClientTileSets(this.appSettings.clientUUID);
    if (this.territory?.tsId){
      this.selectedTileSet = this.clientTileSets.find(tileSet => tileSet.id === this.territory?.tsId)
      if (this.territory?.geoCodes?.length){
        this.selectedTileSetEntities = await getClientTileSetEntities(this.territory);
      }
    }
  }

  commit() {
    this.$emit('commit', {
      tsId: this.selectedTileSet.id,
      geoCodes: this.selectedTileSetEntities.map(entity => entity.geoCode)
    });
  }

  renderHead() {
    return <div class="modal-card-title" style="text-align: center">Territoire</div>
  }

  renderBody() {
    return <div>
      <Columns>
          <Column>
            <Label text="Maille" />
            <XSelect
              allowNull
              nullLabel="-- Mailles disponibles"
              value={this.selectedTileSet?.id}
              data={this.clientTileSets}
              label={tileSet => tileSet.label}
              equality={(tileSet, userTileSetId) => tileSet?.id === userTileSetId}
              onInput={async tileSet => {
                this.selectedTileSet = tileSet;
                this.selectedTileSetEntities = [];
                this.lastEntitiesSearchResult = null; //reset éventuelle dernière recherche
              }}
              readonly={this.clientTileSets.length === 0}
            />
          </Column>
        </Columns>
        <Columns>
          <Column>
            { this.selectedTileSet && (<div>
            <Label text="Entité" />
            <AutoSuggest
              class="filter-objects-editor--operator-value"
              searchAction={q => {
                return getClientTileSetEntities({tsId: this.selectedTileSet.id, query: q, geoCodesExclude: this.selectedTileSetEntities.map(entity => entity.geoCode)});
              }}
              defaultsAction={async () => {
                // return getClientTileSetEntities({tsId: this.selectedTileSet.id});
                //FIXME : alternative compliquée pour ne pas faire des requêtes ralentissant trop la sélection :
                //+ filtrer mais ne filtre pas juste après une sélection :
                if (!this.lastEntitiesSearchResult){
                  return new Promise((resolve) => {
                    getClientTileSetEntities({tsId: this.selectedTileSet.id}).then((entitiesSearchResult) => {
                      this.lastEntitiesSearchResult = entitiesSearchResult.filter(entity => !this.selectedTileSetEntities.map(entity => entity.geoCode).includes(entity.geoCode))
                      resolve(this.lastEntitiesSearchResult);
                    })
                  });
                } else {
                  return this.lastEntitiesSearchResult.filter(entity => !this.selectedTileSetEntities.map(entity => entity.geoCode).includes(entity.geoCode));
                }
              }}
              onSelected={async entity => {
                if (!entity.geoCodes && entity.label){
                  //cas particulier de la recherche et ajout par liste : on reçoit ce qui est saisi un à un dans un "label"
                  const results = await getClientTileSetEntities({tsId: this.selectedTileSet.id, geoCodes:[entity.label]});
                  if (results.length) entity = results[0];
                  else return; //FIXME : rechercher par libellé dans ce cas ?
                }
                if (!this.selectedTileSetEntities.map(entity => entity.geoCode).includes(entity.geoCode)){
                  this.selectedTileSetEntities.push(entity);
                }
              }}
              placeholder="Rechercher ..."
              scopedSlots={{
                row: scope => <div>{scope.geoCode} - {scope.name}</div>
              }}
            />
            </div> )}
          </Column>
        </Columns>
        { this.selectedTileSet && (<div>
        <Columns>
          <Column>
            { this.selectedTileSetEntities.length ? (
              <div style="display:flex;align-items:end">
                <Label text="Entités sélectionnées" />
                <span
                  class="icon icon--primary has-tooltip-top is-small"
                  style="margin:0 0 6px 6px"
                  domPropsInnerHTML={iconDelete}
                  onClick={() => {
                    this.selectedTileSetEntities = [];
                  }}
                  data-tooltip="Vider la sélection"
                />
              </div>
            ) : (
              <Label text="Aucun territoire défini" />
            )}
            <div class="tags-list">
            {
              this.selectedTileSetEntities.map(entitySelection => {
                return <div class={"tag is-primary"}>
                  {entitySelection.name}
                  <button class="delete is-small" onClick={() => {
                    this.selectedTileSetEntities = this.selectedTileSetEntities.filter(entity => entity.geoCode !== entitySelection.geoCode);
                  }} />
                </div>
              })
            }
            </div>
          </Column>
        </Columns>
        </div>)}
    </div>
  }

  renderFooter() {
    return [
      <button class="btn--link-grey" type="button" onClick={this.cancel}>
        Annuler
      </button>,
      <button class="button is-action-primary"
              type="button"
              onClick={() => this.commit()}>
        Valider
      </button>
    ];
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-1c10bbe0/territory-edit-modal.tsx" });